import {number} from 'prop-types';
import {useSelector} from 'react-redux';
import {getAreaUnits} from '@app/selectors/measurements';
import {
  DEFAULT_AREA_FORMAT,
  formatArea,
  localizationMap,
} from '@app/util/format-area.js';

const AreaIndicator = ({squareMeters}) => {
  const units = useSelector(getAreaUnits);
  const area = formatArea(squareMeters, units, DEFAULT_AREA_FORMAT);

  return localizationMap[units] ? `${area} ${localizationMap[units]}` : null;
};

AreaIndicator.propTypes = {
  squareMeters: number,
};

export default AreaIndicator;
